var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPeople = function SvgPeople(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 73,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "people_svg__a",
    width: 73,
    height: 73,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36.5,
    r: 36,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#people_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "people_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M46.702 43.215A15.27 15.27 0 0 0 51.8 31.808c0-8.454-6.854-15.308-15.308-15.308s-15.308 6.854-15.308 15.308a15.27 15.27 0 0 0 5.098 11.407C17.853 47.085 12 55.602 12 65.485v3.513a5.5 5.5 0 0 0 5.502 5.502h37.982a5.5 5.5 0 0 0 5.502-5.502v-3.513c0-9.883-5.854-18.4-14.283-22.27",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#people_svg__b)",
    d: "m46.702 43.215-2.669-2.98-4.544 4.07 5.544 2.545zm-20.419 0 1.67 3.635 5.543-2.545-4.544-4.07zm21.518-11.407a11.27 11.27 0 0 1-3.768 8.427l5.337 5.96a19.27 19.27 0 0 0 6.43-14.387zM36.493 20.5c6.245 0 11.308 5.063 11.308 11.308h8c0-10.663-8.645-19.308-19.308-19.308zM25.185 31.808c0-6.245 5.062-11.308 11.308-11.308v-8c-10.664 0-19.308 8.645-19.308 19.308zm3.767 8.427a11.27 11.27 0 0 1-3.767-8.427h-8a19.27 19.27 0 0 0 6.43 14.386zm-4.338-.655C14.816 44.078 8 53.98 8 65.485h8c0-8.263 4.891-15.393 11.953-18.635zM8 65.485v3.513h8v-3.513zm0 3.513a9.5 9.5 0 0 0 9.502 9.502v-8c-.83 0-1.502-.672-1.502-1.502zm9.502 9.502h37.982v-8H17.5zm37.982 0a9.5 9.5 0 0 0 9.502-9.502h-8c0 .83-.672 1.502-1.502 1.502zm9.502-9.502v-3.513h-8v3.513zm0-3.513c0-11.503-6.817-21.406-16.614-25.905l-3.339 7.27c7.062 3.243 11.953 10.372 11.953 18.635z",
    mask: "url(#people_svg__c)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36.5,
    r: 33,
    stroke: "url(#people_svg__d)",
    strokeWidth: 6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "people_svg__b",
    x1: 36.492,
    x2: 36.492,
    y1: 16.5,
    y2: 74.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C75BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "people_svg__d",
    x1: 36.5,
    x2: 36.5,
    y1: 0.5,
    y2: 72.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C75BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B9F7"
  })))));
};
export default SvgPeople;